<template>
    <div class="thanks-message tw-flex tw-flex-col tw-items-center tw-content-center tw-text-center tw-h-full">
        <h1>Muito obrigado.</h1>
        <p>em breve será contactado(a), para uma breve explicação sobre a forma como vai participar neste grande estudo do consumidor português.<br><br>
        <span>A Equipa Kantar</span></p>
    </div>
</template>

<script>
export default {
    name: 'FormSuccess',
};
</script>
